export interface RegisterReserveSetRequest {
  name: string
  nameKana: string
  bibliographies: {
    bibliographyRealId: number
    rank: number
  }[]
}

export function RegisterReserveSetRequestToJSON(
  value: RegisterReserveSetRequest
): any {
  return {
    name: value.name !== '' ? value.name : undefined,
    name_kana: value.nameKana !== '' ? value.nameKana : undefined,
    bibliographies:
      value.bibliographies.length > 0
        ? value.bibliographies.map(bibliography => {
            return {
              bibliography_real_id:
                bibliography.bibliographyRealId !== 0
                  ? bibliography.bibliographyRealId
                  : undefined,
              rank: bibliography.rank !== 0 ? bibliography.rank : undefined
            }
          })
        : undefined
  }
}
